<template>
  <Card type="warning">
    <template v-slot:header>
      <HeadingSmall
        :class="$style.cardHeading"
      >
        <svg width="19" height="19" fill="none" xmlns="http://www.w3.org/2000/svg" :class="$style.warningMessageIcon" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path fill-rule="evenodd" clip-rule="evenodd" d="M18.04 14.353L11.626 1.52c-1.013-2.028-3.906-2.028-4.919 0L.294 14.353c-.914 1.829.415 3.98 2.46 3.98H15.58c2.044 0 3.374-2.151 2.46-3.98zM8.347 2.34a.916.916 0 011.64 0L16.4 15.173a.917.917 0 01-.82 1.327H2.753a.917.917 0 01-.82-1.327L8.347 2.34zm.816 2.077c-.598 0-1.076.52-1.052 1.143l.197 5.149c.018.478.396.857.855.857.46 0 .838-.379.856-.857l.197-5.15c.024-.623-.454-1.142-1.053-1.142zm-1.26 9.866c0-.711.552-1.287 1.233-1.287.682 0 1.234.576 1.234 1.287 0 .71-.552 1.286-1.234 1.286-.681 0-1.234-.576-1.234-1.287z" fill="#FF7D00"/></svg>
        <span>Running Cloud Formation Template</span>
      </HeadingSmall>
    </template>
    <template v-slot:body>
      <ParagraphBody>
        {{ $options.cftWarning }}
      </ParagraphBody>
    </template>
  </Card>
</template>

<script>
import {
  Card,
  HeadingSmall,
  ParagraphBody,
} from '@jumpcloud/ui-components';

const cftWarning = 'This will create infrastructure in your account, which is needed to integrate with JumpCloud (Cloud Trail, S3 bucket, etc.) and provide access to ingest Cloud Trail logs.';

export default {
  name: 'AddAccountModalCftWarning',

  components: {
    Card,
    HeadingSmall,
    ParagraphBody,
  },

  cftWarning,
};
</script>

<style module scoped>
.cftLink {
  display: inline-block;
  margin-bottom: 15px;
}

.cardHeading {
  align-items: center;
  display: inline-flex;
  gap: 10px;
}

.warningMessageIcon {
  color: var(--jc-color-warning-base);
}
</style>
